<template>
  <div class="icomposite-page">
    <screen-panel :isExpand="isOpen" class="panel">
      <ScreenBoxClick title="车辆概览" menuCode="040501">
        <CarStatics style="margin-top: 10px"></CarStatics>
        <!-- <PeopleTypePie
          :personTypeData="personTypeData"
          style="margin-top: 10px"
        ></PeopleTypePie> -->
      </ScreenBoxClick>
      <screen-box title="车辆吞吐量统计">
        <!-- <CarStatics
          style="margin-top: 10px"
        ></CarStatics> -->
        <CarThroughputStatics></CarThroughputStatics>
      </screen-box>
    </screen-panel>

    <screen-panel :isExpand="isOpen" position="right" class="panel">
      <screen-box title="当前车辆停车时长统计">
        <VehicleParkingSituation style="margin-top: 10px"></VehicleParkingSituation>
      </screen-box>
      <screen-box title="在园车辆趋势">
        <InParkCarCount></InParkCarCount>
      </screen-box>
    </screen-panel>
  </div>
</template>

<script>
import screenPanel from "../components/ScreenPanel.vue";
import ScreenBox from "../components/ScreenBox.vue";
// import PeopleTypePie from "../components/PersonTypePie";
import CarThroughputStatics from "../components/CarThroughputStatics";
import VehicleParkingSituation from "../components/VehicleParkingSituation";
import CarStatics from "../components/CarStatics";
import InParkCarCount from "../components/InParkCarCount";
import ScreenBoxClick from "../components/ScreenBoxClick.vue";

export default {
  data() {
    return {
      personTypeData: {},
      isOpen: false,
    };
  },
  components: {
    screenPanel,
    ScreenBox,
    // PeopleTypePie,
    CarThroughputStatics,
    CarStatics,
    VehicleParkingSituation,
    InParkCarCount,
    ScreenBoxClick
  },

  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    this.isOpen = true;
    this.personTypeData = {
      workNum: 3258,
      visitorNum: 175,
      safeNum: 247,
      cleanNum: 149,
    };
  }
};
</script>
<style lang='scss' scoped>
.panel {
  height: 100%;
}
</style>
